import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, map } from 'rxjs';
import { SharedDataService } from '../services/shared-data.service';
import { UserValidationService } from '../services/user-validation.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(
    private sharedDataService: SharedDataService,
    private router: Router,
    private userValidationService: UserValidationService
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.userValidationService.hasPendingOtpSession()) {
      this.router.navigate(['/otp-auth']);
      return false;
    }

    if (this.userValidationService.hasPendingCompanySelection()) {
      this.router.navigate(['/workspace-selection']);
      return false;
    }

    return this.userValidationService.ensureAuthenticatedSession().pipe(
      map((isAuthenticated) => {
        const user = this.sharedDataService.getAgent();

        if (isAuthenticated) {
          this.router.navigate(['/workspace-selection']);
          return false;
        }

        if (!isAuthenticated && user) {
          this.sharedDataService.clearUser();
        }

        return true;
      })
    );
  }
}
